//axios拦截器
import axios from "axios";
import {Message} from 'element-ui';
import eventBus from "@/utils/eventBus";
import {Base64} from 'js-base64'

function debounce(fn, wait) {
  //wait间隔内执行一次fn的函数
  let timerId = null;
  let firstFlag = true;
  return function () {
    clearTimeout(timerId);
    if (firstFlag) {
      fn.apply(this, arguments);
      firstFlag = false;
    }
    timerId = setTimeout((msg) => {
      firstFlag = true;
    }, wait)
  }
}

const alert_and_login_per_second = debounce((msg) => {
  window.Vue.prototype.logout(true);
  Message.error({
    showClose: true,
    message: msg,
    duration: 3000
  });

  setTimeout(function () {
    let matched = document.location.pathname.match(/^(\/innerApp\/[^\/?]+)/i);
    let loginUrl = matched? matched[1]: "/login";
    window.location = loginUrl;
  }, 2000);

}, 3000)

axios.interceptors.request.use(
  config => {
    // console.log("request=" + JSON.stringify(config));


    let top;
    let top_href = "login";
    try{
      // 当应用被嵌入到iframe（域名不是hylanda）时，window.top 抛跨域异常
      top = window.top.document.location;
      top_href = top.href;
    }
    catch (e) {}

    // adp的非登录页，如果cookie里没有userid，跳转到登录页
    if(top_href.indexOf("innerApp") == -1 && top_href.indexOf("login") == -1 && top_href.indexOf("shareproject") == -1){
      let cookie_uid = -1;
      if(document.cookie){
        let cookies = document.cookie.split("; ");
        for (let i = 0; i < cookies.length; i++) {
          let temp = cookies[i].split("=");
          if (temp[0] == "userid")
            cookie_uid = temp[1];
        }

        if(cookie_uid == -1 || cookie_uid == undefined || cookie_uid == null)
          window.location = top.protocol + "//" + top.host + "/login";
      }
    }

    if (config.url && config.url.length > 0) {
      if (config.url.startsWith("/nifi-man/wan/get_datacanvas_url")
        || config.url.startsWith("/painter")) {
        let token = localStorage.getItem("hl_api_token");
        config.headers['hl-api-token'] = token;
      }
      if( config.url == '/innerApp/api/login'){
        //应用登录接口，对用户名密码进行简单加密
        // let Base64 = require("js-base64").Base64;
        let form_json = JSON.parse(config.data)
        form_json['password'] = `BSF(${Base64.encode(form_json['password'])})`;
        form_json['username'] = `BSF(${Base64.encode(form_json['username'])})`;
        config.data = JSON.stringify(form_json)
      }
    } else {
      alert("研发错误：ajax请求url为空");
    }
    if (!config.headers['wkcheck']) {
      config.headers['wkcheck'] = 'hylanda';
    }

    return config;
  },
  error => {
    // console.log("requesterr=" + JSON.stringify(error)); // for debug
    return Promise.reject(error)
  }
);

// http response 服务器响应拦截器，
// 这里拦截401错误，并重新跳入登页重新获取token
axios.interceptors.response.use(
  response => {
    // console.log("response=" + JSON.stringify(response));
    if(response.data && response.data.data ){
      if(response.data.data.extraneous_information) {
        if (response.data.data.extraneous_information.eventName) {
          eventBus.$emit(response.data.data.extraneous_information.eventName, response.data.data.extraneous_information)
        }
      }
      if (response.data.__hylanda_windows_call){
          if(response.data.__hylanda_windows_call.session_storage){
            for (let key in response.data.__hylanda_windows_call.session_storage) {
              window.sessionStorage.setItem(key,response.data.__hylanda_windows_call.session_storage[key])
            }
          }
      }
    }
    if (response.data && response.data.code == '500') {
      if (response.data.msg) {
        Message.error({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: response.data.msg,
          duration: 5000
        })
      }
    } else if (response.data && response.data.code == 1000 && response.data.message == "登录失效") {
      if (response.config.allowAxios == null || response.config.allowAxios) {
        alert_and_login_per_second("登录已过期，请重新登录");
      }
    } else if (response.data && response.data.code == 1000 && response.data.message == "鉴权失败") {
      if (response.config.allowAxios == null || response.config.allowAxios) {
        alert_and_login_per_second("鉴权失败，请重新登录");
      }
    }else if (response.data && response.data.code < 0) {
      if (response.data.err && response.data.err.length > 0) {
        Message.error({
          showClose: true,
          message: response.data.err,
          duration: 5000
        })
      } else if (response.data.msg && response.data.msg.length > 0) {
        Message.error({
          showClose: true,
          message: response.data.msg,
          duration: 5000
        })
      } else {
        console.log(response.data)
      }
    }
    return response;
  },
  error => {
    // console.log("responseerr=" + JSON.stringify(error));
    if (error && error.config && error.config.url && ~error.config.url.indexOf("get_resource_usage_real_time")){
      console.log(error.message)
    }
    else if (error.message == "Request failed with status code 302") {
      alert_and_login_per_second("登录已过期，请重新登录");
    } else if (error.response) {
      switch (error.response.status) {
        case 401:
          alert_and_login_per_second("登录已过期，请重新登录");
          if (error.response.headers.location){
            //amis后端返回401，指定location，就能自由跳转adp和login或应用自己的login了
            window.location.href=error.response.headers.location;
          }
          break;
        case 403:
          alert_and_login_per_second("登录已过期，请重新登录");
          break;
        case 502:
        case 504:
          Message.error({
            showClose: true,
            message: "后台服务异常，请稍后重试：" + error.message,
            duration: 5000
          });
          break;
        default:
          Message.error({
            showClose: true,
            message: error.message,
            duration: 5000
          });
          break;
      }
    } else if (error.message) {
      Message.error({
        showClose: true,
        message: error.message,
        duration: 5000
      })
    }
    return Promise.reject(error)
  }
);
